import React, { useCallback, useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import axios from "axios";
import fileDownload from "js-file-download";

import { SiteContext } from "../../context/SiteContext";
import { UserContext } from "../../context/UserContext";

const CreditNote = ({orderId}) => {
    const { env, csrfToken } = useContext(SiteContext);
    const { user } = useContext(UserContext);

    const [creditNoteLoading, setCreditNoteLoading] = useState(false);

    const downloadCreditNote = useCallback(
        () => {
            setCreditNoteLoading(true);

            axios.get(
                env.webApiBaseUrl + "/orders/" + orderId + "/creditNote",
                {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-Token": csrfToken,
                        Authorization: "Bearer " + user.token,
                    },
                    withCredentials: true,
                    responseType: "blob",
                    timeout: 60000,
                }
            )
            .then ((response) => {
                const filename = "creditNote-" + orderId + "-" + Date.now() + ".pdf";
                fileDownload(response.data, filename);
            })
            .catch ((e) => {
                console.error(
                    "Problemas al obtener la nota de crédito: ",
                    e
                );
            })
            .finally(() => {
                setCreditNoteLoading(false);
            });
        },
        [csrfToken, env.webApiBaseUrl, orderId, user.token],
    );

    return (
        <Button size="sm" variant="primary" onClick={downloadCreditNote} alt="Ver nota de crédito">
            {creditNoteLoading
            ? <Spinner animation="border" role="status" size="sm"/>
            : <FaMoneyCheckAlt className="lead"/>
            }
        </Button>
    );
}

export default CreditNote;